/**
 * State type when a user click on a prevLink or a NextLink
 */
export enum LinkClickSateType {
    ALLOWED = 'ALLOWED',
    IMPOSSIBLE = 'IMPOSSIBLE'
}
